import * as React from 'react';
import { observer } from 'mobx-react';
import ErrorUtil from '../../util/ErrorUtil';
import BankForm from './BankForm';
import { Notice, Separator, Spinner } from 'telia-front-react';
import { useParams } from 'react-router-dom';
import useStores from '../../stores/UseStores';

const BankFormWrapper = observer((): React.JSX.Element => {
  const { authService } = useParams();
  const {
    translateStore: { translate },
  } = useStores();

  if (!authService) {
    const error = new Error('authService has no value');
    error.stack = `page: ${window.location.pathname}`;
    const code = ErrorUtil.pushErrorToTeliaRumAndGetTransaction(error);
    return (
      <div>
        <Separator spacing="large" color="invisible" />
        <Notice type="error">
          <b>{translate('error.general')}</b>
          <>
            <br />
            {code}
          </>
        </Notice>
        <Separator spacing="large" color="invisible" />
      </div>
    );
  }

  const { banksLoginStore } = useStores();

  React.useEffect(() => {
    banksLoginStore.initializeBankFormData(authService);
  }, []);

  if (!banksLoginStore.bankFormInitialized) {
    return <Spinner />;
  }

  return <BankForm formPostUrl={banksLoginStore.formPostUrl} redirectData={banksLoginStore.redirectData} />;
});

export default BankFormWrapper;
